import type {
	RemoveNodesCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';
import { createRemoveNodeCommand } from './remove';

export const createRemoveNodesCommand: StreamingCommandFactory<RemoveNodesCommand> =
	(api) => (command) => {
		const removeNode = createRemoveNodeCommand(api);
		for (const localId of command.localIds) {
			removeNode({ type: 'removeNode', localId });
		}
		return true;
	};
